// 生成min-max随机数
function randomNum(min, max) {
    var range = max - min;
    var rand = Math.random();
    var num = min + Math.floor(rand * range);
    return num;
}
async function upFile(axios, url, file) {
    let uploadParams = {};
    let filename = "";

    /**计算唯一名称 */
    function getFileName() {
        let filename = "";
        let ext = file.name.split(".").pop();
        // 名字由时间戳 ＋ 1000-9999随机数
        filename = `${new Date().getTime()}${randomNum(1000, 9999)}.${ext}`;
        return filename;
    }

    /**获取上传的参数 */
    function getUploadParams() {
        return new Promise((resolve, reject) => {
            axios.get({
                api: url,
                data: {
                    filename
                },
                success: resolve,
                error: reject
            });
        });
    }
    /**上传文件 */
    function uploadQuest() {
        const baseUpData = {
            policy: uploadParams.policy,
            signature: uploadParams.signature,
            OSSAccessKeyId: uploadParams.access_id,
            success_action_status: "200",
            name: uploadParams.filename,
            key: uploadParams.dir +uploadParams.filename,
            file: file.raw
        };
        return new Promise((resolve, reject) => {
            axios.file({
                progress: () => {},
                api: uploadParams.host,
                data: baseUpData,
                success: resolve,
                error: reject
            });
        });
    }
    async function handleUpload() {
        filename = getFileName();
        const res = await getUploadParams();
        uploadParams = res.data;
        uploadQuest();
        return uploadParams.url;
    }
    return await handleUpload();
}

export default upFile;